import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/app/middleware/01.auth.global.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}